import { Heading } from '@/components/ui/heading';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import { PatientTabs, type PatientTabKey } from './PatientTabs';
import DemoPatientBanner from './DemoPatientBanner';
import { router } from '@inertiajs/react';

type PatientSummary = {
  id: number;
  display_name?: string;
  name?: string;
  email?: string | null;
  demo?: boolean;
};

type Props = {
  patient: PatientSummary;
  active: PatientTabKey;
  title?: string;
  subtitle?: ReactNode;
  rightSlot?: ReactNode;
  className?: string;
  onDeleteDemo?: () => void;
};

export function PatientPageHeader({
  patient,
  active,
  title,
  subtitle,
  rightSlot,
  className,
  onDeleteDemo,
}: Props) {
  const resolvedTitle =
    title || patient.display_name || patient.name || patient.email || `Paziente #${patient.id}`;
  const isDemo = Boolean(patient.demo);
  const handleDelete =
    onDeleteDemo ||
    (() => router.delete(`/therapists/patients/${patient.id}`, { preserveScroll: true }));

  return (
    <header className={cn('space-y-3', className)}>
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <Heading level={1}>{resolvedTitle}</Heading>
          {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
        </div>
        {rightSlot}
      </div>
      {isDemo ? <DemoPatientBanner onDelete={handleDelete} /> : null}
      <PatientTabs patientId={patient.id} active={active} />
    </header>
  );
}
